export default "__VITE_PUBLIC_ASSET__31ece68b__"